import React from "react";
import MultiColumnContent from "./multi-column-content";
import SingleColumnContent from "./single-column-content";
import LogosSection from "./logos-section";
import FeaturedBlocks from "./featured-blocks";
import IntegrationsSection from "./integrations-section";
import FeaturedImage from "./featured-image";
import ContentGrid from "./content-grid";
import PartnersGrid from "./partners-grid";
import MultiColumnContentWithImage from "./multi-column-content-with-image";
import TestimonialsSection from "./testimonials-section";
import NewsSection from "./news-section";

function FlexibleContent({ items }) {
  return (
    <>
      {items.map(node => {
        switch (node._type) {
          case `multiColumnContent`:
            return <MultiColumnContent {...node} dark="true" />
          case `logosSection`:
            return <LogosSection {...node} />
          case `featuredBlocks`:
            return <FeaturedBlocks items={node.featuredBlocks} />
          case `integrationsSection`:
            return <IntegrationsSection {...node} />
          case `featuredImage`:
            return <FeaturedImage {...node} />
          case `contentGrid`:
            return <ContentGrid {...node} />
          case `partnersGrid`:
            return <PartnersGrid {...node} />
          case `multiColumnContentWithImage`:
            return <MultiColumnContentWithImage {...node} />
          case `singleColumnContent`:
            return <SingleColumnContent {...node} />
          case `testimonialsSection`:
            return <TestimonialsSection {...node} />
          case `newsSection`:
            return <NewsSection {...node} />
          default:
            return null
        }
      })}
    </>
  );
}

export default FlexibleContent;
